import { render, staticRenderFns } from "./UserAccessDenied.vue?vue&type=template&id=98d3188a&scoped=true"
import script from "./UserAccessDenied.vue?vue&type=script&lang=js"
export * from "./UserAccessDenied.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98d3188a",
  null
  
)

export default component.exports